<script setup>
  import { ref, watchEffect, onUnmounted } from "vue";
  import { useMapStore } from "@/stores/MapStore";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { useToaster } from '@/composables/useToaster';

  const mapStore = useMapStore();

  const toaster = useToaster();
  const fxMapAllowedWidth = useMediaQuery('(max-width: 2600px)');
  const fxMapAllowedHeight = useMediaQuery('(max-height: 2000px)');

  const mapZoomListener = ref(null);

  const showFxMapScreenSizeToast = () => {
    toaster.toast({
      key: 'fxMapSize',
      type: 'warning',
      title: 'Screen Size Too Large',
      contentHtml: 'Forecast maps will not display at this screen size. <i>Maximum size is 2600 x 2000 pixels.</i>',
    })
  }

  const checkRadarMapZoomLevel = () => {
    if (window.$JWX.map && window.$JWX.map.getZoom() === 13) {
      toaster.toast({
        key: 'radarZoomLevel',
        type: 'warning',
        title: 'Max Zoom Level',
        content: 'Turn radar off to zoom in further.',
      })
    } else {
      toaster.clear('radarZoomLevel');
    }
  }

  watchEffect(() => {
    if (mapStore.state.obsOverlays.has('radar')) {
      checkRadarMapZoomLevel();

      mapZoomListener.value = window.$JWX.map.addListener('zoom_changed', checkRadarMapZoomLevel)
    } else {
      toaster.clear('radarZoomLevel')
    }
  })

  watchEffect(() => {
    if (mapStore.mapMode.toLowerCase() === 'fx' && (!fxMapAllowedWidth.value || !fxMapAllowedHeight.value)) {
      showFxMapScreenSizeToast();
    } else {
      toaster.clear('fxMapSize')
    }
  })

  onUnmounted(() => {
    if (mapZoomListener.value) {
      window.$JWX.map.removeListener(mapZoomListener.value);
    }

    toaster.clear('fxMapSize');
    toaster.clear('radarZoomLevel');
  })
</script>

<template></template>
